import type { FC } from 'react';
import type { ComponentsAndAccessoriesEntity } from '../../../../../@types/gql/product-detail';

const ProductDetailComponentsAndAccessories: FC<{
  data: ComponentsAndAccessoriesEntity[];
}> = ({ data }) => {
  return (
    <div className="">
      {data.map(({ id, Heading, Content }) => {
        return (
          <div key={id}>
            {/* <p className="px-5 py-4 text-xl text-[#121212] text-left font-bold divide-x border divide-[#BDBDBD] bg-[#F4F4F4] border-[#BDBDBD] max-md:text-lg">
              {Heading}
            </p> */}
            <div className="overflow-x-auto mt-10">
              <table className="w-full min-w-[700px] ">
                <thead className="bg-[#F4F4F4]">
                  <tr className="divide-x border divide-[#BDBDBD] bg-[#F4F4F4] border-[#BDBDBD]">
                    <th className="px-5 py-4 font-bold uppercase text-[#121212] text-left max-md:text-base"
                      colSpan={2}
                      key={id}
                    >
                      {Heading}
                    </th>
                  </tr>
                </thead>
                <tbody className="border border-gray-950">
                  <tr className="divide-x border divide-[#BDBDBD] border-[#BDBDBD]">
                    {Content?.map(({ Title, id: idd, List }) => {
                      return (
                        <td
                          className="px-10 py-10 text-left align-baseline"
                          key={idd}
                        >
                          {' '}
                          <p className="font-bold text-[#121212] max-md:text-base">
                            {Title}
                          </p>
                          <ul className="list-disc list-inside">
                            {List?.map(({ Name, id: lid }) => {
                              return (
                                <li
                                  className="my-px py-1 text-base text-[#121212] text-left font-medium max-md:text-base"
                                  key={lid}
                                >
                                  {Name}
                                </li>
                              );
                            })}
                          </ul>
                        </td>
                      );
                    })}
                  </tr>

                  {/* {Content?.map(({ Title, id: idd, List }) => {
                  return (
                    <tr
                      className="divide-x border divide-[#BDBDBD] border-[#BDBDBD]"
                      key={idd}
                    >
                      <td className="px-5 py-4 text-left">
                        <p className="text-xl font-bold text-[#121212] max-md:text-base">
                          {Title}
                        </p>
                        <ul className="list-disc list-inside">
                          {List?.map(({ Name, id: lid }) => {
                            return (
                              <li
                                className="my-px py-1 text-xl text-[#121212] text-left font-medium max-md:text-base"
                                key={lid}
                              >
                                {Name}
                              </li>
                            );
                          })}
                        </ul>
                      </td>
                    </tr>
                  );
                })} */}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductDetailComponentsAndAccessories;
